export default __webpack_public_path__ + "static/media/crop.7a825649.svg";